import { getAuth, onAuthStateChanged } from "firebase/auth";

export const waitForAuthReady = () =>
  new Promise(resolve => {
    const unsub = onAuthStateChanged(getAuth(), user => {
      unsub();
      resolve(user);
    });
  });